import { Currency } from "./currency";
import { SalesProductType } from "./sales-product-type";
import Decimal from 'decimal.js';

export class BookingPreConfirmationProduct {

    constructor(
        public productType: SalesProductType,
        public description: string,
        public amount: Decimal,
        public currency: Currency,
        public amountInEuro: Decimal | null,
        public id?: number
    ){}
}
